import React from 'react';
import styled from 'styled-components';
import { Icon, RouteLink } from '~/components';
import { colors, weights } from '~/styles';

// Renderer for the `sitemap-url-builder` tool: each resolved destination is a
// clickable navigation link. A plain click navigates in the same window (React
// Router); ⌘/Ctrl-click opens a new tab (native anchor). The leading link icon
// signals an in-app navigation link.
const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0.75rem 0;
  `,

  Item: styled(RouteLink)`
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    padding: 0.625rem 0.75rem;
    border: 1px solid ${colors.grey10};
    border-radius: 0.5rem;
    color: ${colors.black};

    &:hover {
      background: ${colors.grey5};
      color: ${colors.black};
      opacity: 1;
    }
  `,

  Leading: styled.div`
    flex-shrink: 0;
    margin-top: 0.0625rem;
    color: ${colors.primary};
    font-size: 0.875rem;
  `,

  Body: styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 0.125rem;
  `,

  Section: styled.span`
    color: ${colors.grey40};
    font-size: 0.625rem;
    font-weight: ${weights.black};
    letter-spacing: 0.0625rem;
    text-transform: uppercase;
  `,

  Label: styled.span`
    font-weight: ${weights.bold};
    font-size: 0.875rem;
  `,

  Description: styled.span`
    color: ${colors.grey75};
    font-size: 0.75rem;
  `,
};

export default function SitemapLink({ data }) {
  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <S.Container>
      {data.map((row, i) => (
        <S.Item key={i} to={row.url}>
          <S.Leading>
            <Icon icon="link" />
          </S.Leading>
          <S.Body>
            {row.section && <S.Section>{row.section}</S.Section>}
            <S.Label>{row.label}</S.Label>
            {row.description && <S.Description>{row.description}</S.Description>}
          </S.Body>
        </S.Item>
      ))}
    </S.Container>
  );
}
